import { Box, Heading, Text } from '@wix/design-system';
import React from 'react';
import { DomainSearchGateModule } from '../../../../module/domainSearchGate.module';
import { InfoRow } from './InfoRow';
function formatStatusLabel(code) {
  // Handle both "client transfer prohibited" and "clientTransferProhibited"
  const spaced = code.replace(/([a-z])([A-Z])/g, '$1 $2');
  return spaced.split(/[\s]+/).map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
}
const formatDate = date => {
  if (!date) {
    return undefined;
  }
  try {
    return new Date(date).toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  } catch {
    return date;
  }
};
export const DomainInfoSection = _ref => {
  let {
    domainInfo,
    collapsed = false
  } = _ref;
  const {
    t
  } = DomainSearchGateModule.internals.useTranslations();
  const notAvailable = '—';
  // Collapsed (mobile "Show more"): only the first nameserver, no status row.
  const nameservers = collapsed ? domainInfo.nameservers.slice(0, 1) : domainInfo.nameservers;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP4"
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "medium",
    as: "h2"
  }, t('domain_search_gate.whois_results.info_card.domain_info.title')), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP3"
  }, /*#__PURE__*/React.createElement(InfoRow, {
    label: t('domain_search_gate.whois_results.info_card.domain_info.created_date.label'),
    value: formatDate(domainInfo.created) ?? notAvailable
  }), /*#__PURE__*/React.createElement(InfoRow, {
    label: t('domain_search_gate.whois_results.info_card.domain_info.updated_date.label'),
    value: formatDate(domainInfo.updated) ?? notAvailable
  }), /*#__PURE__*/React.createElement(InfoRow, {
    label: t('domain_search_gate.whois_results.info_card.domain_info.expires_date.label'),
    value: formatDate(domainInfo.expires) ?? notAvailable
  }), /*#__PURE__*/React.createElement(InfoRow, {
    label: t('domain_search_gate.whois_results.info_card.domain_info.nameservers.label'),
    value: domainInfo.nameservers.length > 0 ? /*#__PURE__*/React.createElement(Box, {
      direction: "vertical"
    }, nameservers.map(ns => /*#__PURE__*/React.createElement(Text, {
      size: "small",
      key: ns
    }, ns))) : notAvailable
  }), !collapsed && /*#__PURE__*/React.createElement(InfoRow, {
    label: t('domain_search_gate.whois_results.info_card.domain_info.status.label'),
    value: domainInfo.status.length > 0 ? /*#__PURE__*/React.createElement(Box, {
      direction: "vertical",
      gap: "SP1"
    }, domainInfo.status.map(s => /*#__PURE__*/React.createElement(Text, {
      size: "small",
      key: s.code
    }, formatStatusLabel(s.code)))) : notAvailable
  })));
};
//# sourceMappingURL=DomainInfoSection.js.map